import { render, staticRenderFns } from "./VsTooltip.vue?vue&type=template&id=68b0eb99&scoped=true&"
import script from "./VsTooltip.vue?vue&type=script&lang=js&"
export * from "./VsTooltip.vue?vue&type=script&lang=js&"
import style0 from "./VsTooltip.vue?vue&type=style&index=0&id=68b0eb99&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b0eb99",
  null
  
)

export default component.exports